import { useState } from "react";
import { useRecoilState } from "recoil";
import { changeFactorStepFlagsAtom } from "stores";
import { removeArrayItemAt } from "utils";

export function useChangeStepFlags() {
  const [changeStepFlags, setChangeStepFlags] = useRecoilState(
    changeFactorStepFlagsAtom
  );

  const goToCountEditingMode = () =>
    setChangeStepFlags((prev) => ({
      multiChangeStep: false,
      singleChangeStep: [],
      countEditingMode: true,
    }));

  const closeCountEditingMode = () =>
    setChangeStepFlags((prev) => ({
      multiChangeStep: false,
      singleChangeStep: [],
      countEditingMode: false,
    }));

  const goToSingleItemChangeStepMode = (id: number) => {
    setChangeStepFlags((prev) => ({
      multiChangeStep: false,
      singleChangeStep: [...prev.singleChangeStep, id],
      countEditingMode: false,
    }));
  };

  const closeSingleItemChangeStepMode = (id: number) => {
    const idIndex = changeStepFlags.singleChangeStep.indexOf(id);
    const tmp = removeArrayItemAt(changeStepFlags.singleChangeStep, idIndex);
    setChangeStepFlags({
      singleChangeStep: tmp,
      multiChangeStep: false,
      countEditingMode: false,
    });
  };

  const goToMultiItemsChangeStepMode = () => {
    setChangeStepFlags((prev) => ({
      multiChangeStep: true,
      singleChangeStep: [],
      countEditingMode: false,
    }));
  };

  const closeItemChangeStepMode = () => {
    setChangeStepFlags({
      singleChangeStep: [],
      multiChangeStep: false,
      countEditingMode: false,
    });
  };

  const singleItemChangeStepMode = (id: number) =>
    changeStepFlags.singleChangeStep.includes(id);

  const singleItemChangeStepModeForAll =
    changeStepFlags?.singleChangeStep?.length > 0;

  const multiItemsChangeStepMode = changeStepFlags.multiChangeStep;
  const singleItemsChangeStepLength = changeStepFlags?.singleChangeStep?.length;
  const countEditingMode = changeStepFlags.countEditingMode;

  return {
    goToSingleItemChangeStepMode,
    goToMultiItemsChangeStepMode,
    closeItemChangeStepMode,
    singleItemChangeStepMode,
    closeSingleItemChangeStepMode,
    singleItemChangeStepModeForAll,
    singleItemsChangeStepLength,
    multiItemsChangeStepMode,
    countEditingMode,
    goToCountEditingMode,
    closeCountEditingMode,
  };
}
